module.exports = __webpack_public_path__ + "static/img/jt0.8493663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/jt0.jpg
// module id = HeKN
// module chunks = 1